module.exports = __webpack_public_path__ + "img/til_yes.3d53f863.png";